
/* injects from baggage-loader */

export const failDialg = [`Parece que você se <b>confundiu</b>! <br> <b>Observe</b> novamente e <b>reescreva</b> os numerais apenas nos <b>quadrinhos destacados</b> com a cor vermelha.`]
export const successDialg = [`Você <b>conseguiu criar</b> um <b>gráfico</b> corretamente. Agora, vamos <b>analisar</b> as <b>informações</b> que você escreveu.`]


// WEBPACK FOOTER //
// ./src/app/components/dialogs/graph-onca/graph-onca.const.js